import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { fuseAnimations } from '../../../../../../../../../../core/animations';
import { SpreadsheetComponent } from '@syncfusion/ej2-angular-spreadsheet';
import * as _ from 'lodash';
//Service files
import { SideNavService } from '../../../../sidenav.service';

//Common components
import { ToastComponent } from '../../../../../../../common/toast.component';

//Common values and models files
import { BytheFootSection, toolTip, kpiDisplayValues } from '../../../../../../../utils';
import { KpiDataSets } from '../../../../../../../models';

@Component({
  selector: 'spekwo-kpi-sheet-view',
  templateUrl: './kpi-sheet-view.component.html',
  styleUrls: ['./kpi-sheet-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class KpiSheetViewComponent implements OnInit {

  kpiDisplayValues = kpiDisplayValues;
  nameValues = BytheFootSection;
  toolTip = toolTip;

  currentDate: Date = new Date();
  currentMonth: number;
  currentMonthString: string;
  currentYr: number;
  selectedMonth: number;
  monthNames: string[] = kpiDisplayValues.spekwoKpi.monthNames;
  formLoader: boolean = false;
  sheetLoader: boolean = false;
  kpiId: number;
  totalLength: number;
  isKPIUpdated: Observable<boolean>;
  private _subscriptions: Subscription[] = [];


  @ViewChild('default')
  public spreadsheetObj: SpreadsheetComponent;
  public openUrl: string = 'https://ej2services.syncfusion.com/production/web-services/api/spreadsheet/open';
  public saveUrl: string = 'https://ej2services.syncfusion.com/production/web-services/api/spreadsheet/save';



  public data: any[][] = [];

  constructor(
    /** Local component */
    private toastComponent: ToastComponent,
    private _SideNavService: SideNavService,
  ) { this.isKPIUpdated = this._SideNavService.onKpiDetailsChanged.asObservable(); }

  ngOnInit() {

    //Subscription to watch any changes happen in kpi values
    this._subscriptions.push(
      this._SideNavService.onKpiDetailsChanged.subscribe(response => {
        this.sheetLoader = true;
        this.data = [];
        this.assignDataSheetValues(response.allKpiList);
      }, () => {
        this.sheetLoader = false;

      })
    );

    //Getting current month && year
    this.currentMonth = this.currentDate.getMonth();
    this.currentMonthString = this.monthNames[this.currentMonth];
    this.currentYr = this.currentDate.getFullYear();
    this.selectedMonth = this.currentMonth;
  }

  ngOnDestroy() {
    this._subscriptions.forEach(subscriptions => subscriptions.unsubscribe());
  }

  //Pushing kpi values to the sheet
  assignDataSheetValues(allKpiValues: KpiDataSets[]) {
    this.totalLength = allKpiValues.length;
    _.each(allKpiValues, (details: KpiDataSets, i: number) => {
      this.data.push(['', this.monthNames[details.month], details.year, '']),
        this.data.push([kpiDisplayValues.spekwoKpi.tableHeads.sales, '', kpiDisplayValues.spekwoKpi.tableHeads.itemRev,
        kpiDisplayValues.spekwoKpi.tableHeads.grossRev]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.spekOrdered, details.fullSpekwo.total,
        '$' + details.fullSpekwo.itemRev, '$' + details.fullSpekwo.grossRev]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.spekApproved, details.spekApproved.total,
        '$' + details.spekApproved.itemRev, '$' + details.spekApproved.grossRev]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.spekWalkOrdered, details.spekWalk.total,
        '$' + details.spekWalk.itemRev, '$' + details.spekWalk.grossRev]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.spekCallOrdered, details.spekCall.total,
        '$' + details.spekCall.itemRev, '$' + details.spekCall.grossRev]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.revenueForSpekPro, details.revenueForSpekPro.total,
        '$' + details.revenueForSpekPro.itemRev, '$' + details.revenueForSpekPro.grossRev]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.revenueForSpekInternalPro,
        '$' + details.revenueForSpekInternalPro]),
        this.data.push([]),
        this.data.push([kpiDisplayValues.spekwoKpi.tableHeads.marketing]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.ouboundCalls, details.numberOfOutBoundCalls]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.emailCapaigns, details.numberOfEmailCampaigns]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.livePresentation, '$' + details.amtSpentLivePresent]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.amtSpenForFb, '$' + details.amtSpentFb]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.amtSpenForInsta, '$' + details.amtSpentInsta]),
        this.data.push([kpiDisplayValues.spekwoKpi.kpiFieldsName.amtSpenForLinkedIn, '$' + details.amtSpentLinkedIn]),
        this.data.push([''])
      if (allKpiValues.length == i + 1) {
        this.sheetLoader = false;
        this.formLoader = false;
      }
    });

  }

  //Databound to sheet values and cells
  dataBound() {
    if (!this.spreadsheetObj.isOpen &&
      this.spreadsheetObj.sheets[this.spreadsheetObj.activeSheetTab - 1].name === kpiDisplayValues.spekwoKpi.kpiSheetValues.sheetTitle) {
      var dateCell = 2;
      var sales = dateCell + 1;
      var marketing = sales + 8;
      var startLimit: string;
      var endlimit: string;
      var limit: string;
      //Based on length applying cell style
      for (let i = 0; i < this.totalLength; i++) {

        startLimit = 'A' + dateCell;
        endlimit = 'E' + dateCell;
        limit = startLimit + ':' + endlimit
        this.spreadsheetObj.cellFormat({ fontWeight: 'bold' ,fontSize: '12pt'}, limit);

        startLimit = 'A' + sales;
        endlimit = 'E' + sales;
        limit = startLimit + ':' + endlimit
        this.spreadsheetObj.cellFormat({ fontWeight: 'bold' }, limit);

        startLimit = 'A' + marketing;
        endlimit = 'E' + marketing;
        limit = startLimit + ':' + endlimit
        this.spreadsheetObj.cellFormat({ fontWeight: 'bold' }, limit);

        dateCell = marketing+8;
        sales = dateCell + 1;
        marketing = sales + 8;
      }
    }
  }

}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/kpi/kpi-sheet-view/kpi-sheet-view.component.ts